import {
    makeStyles,
    Theme,
    createStyles,
    Grid,
    Typography,
    TextField,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { StandardTextField } from "../components/StandardTextField";
import { Rating, Stack } from "@mui/material";
import { AnnounceTextFieldMultine } from "../../Announces/components/AnnounceTextFieldMultine";
import { PropertyTextFieldNumber } from "../../Properties/components/PropertyTextFieldNumber";
import { SelectEndornmentNation } from "../../components/Register/TextFieldNation";
import { CountryPhoneList } from "../../../utils/CountryList";
import AutoCompleteSolo from "../../components/OverridingMaterial/AutoCompleteSolo";
const styles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            width: "100%",
            textAlign: "center",
            [theme.breakpoints.down("sm")]: {
                minHeight: 1200,
            },
            [theme.breakpoints.up("lg")]: {
                minHeight: 800,
            },
        },

        inpuText: {
            marginBottom: theme.spacing(5),
        },
        uploadFile: {
            width: "100%",
            background: "antiquewhite",
            padding: "14px",
            minHeight: "6em",
            marginBottom: "16px",
            fontFamily: "Josefin Sans",
            textTransform: "inherit",
            fontSize: 18,
            borderRadius: 8,
        },
        changeImage: {
            fontFamily: "Josefin Sans",
            textTransform: "inherit",
            fontSize: 14,
        },

        propertiesHeader: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        propertiesTitle: {
            fontSize: 22,
            fontFamily: "Josefin Sans",
            color: "#890608",
            marginTop: 40,
            marginBottom: 60,
        },
        propertiesStepper: {
            width: "40%",
            marginBottom: 70,

            [theme.breakpoints.down("sm")]: {
                width: "70%",
            },
        },
        propertiesCheck: {},
        propertiesCheckbox: {
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        checkboxLabel: {
            "&:not(:last-child)": {
                marginBottom: 20,
            },
            "& span": {
                fontFamily: "Josefin Sans",
                color: "#5F5F5F",
            },
        },
        checkboxLegend: {
            textAlign: "left",
            fontSize: 18,
            fontFamily: "Josefin Sans",
            color: "#000000",
            marginBottom: 30,
        },
        checkboxGroup: {},
        propertiesBtn: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: 50,
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        Button: {
            fontFamily: "Josefin Sans",
            color: "#890608",
            textTransform: "capitalize",
        },
        ButtonPrevious: {
            textTransform: "capitalize",
            color: "#000000",
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        containerLabel: {
            textAlign: "left",
        },
        announcePriceContainer: {
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
        },
        announcePriceItem: {
            flex: 0.47,
        },
        "@global": {
            ".MuiOutlinedInput-input": {
                padding: "9px 14px",
            },
        },
        formContainer: {
            margin: "0 auto",
        },
        gridContainer: {},

        avatar: {
            display: "flex",
            width: 100,
            height: 100,
            border: "1px solid",
            borderRadius: "50%",
            alignItems: "center",
            justifyContent: "center",
            backgroundSize: "cover",
        },
        imgUpload: {
            display: "flex",
            width: 220,
            height: 160,
            border: "1px solid",
            alignItems: "center",
            justifyContent: "center",
            backgroundSize: "cover",
        },
        avatarProfil: {
            display: "flex",
            flexDirection: "column",
            marginTop: 15,
            marginBottom: 10,
        },
        isPreviewing: {
            color: "white",
            borderRadius: "50%",
            background: "#EA7606",
        },
        isNotPreviewing: {
            color: "#000000",
            borderRadius: "inherit",
            background: "inherit",
        },
        span: {
            display: "flex",
            justifyContent: "center",
            marginTop: 9,
            fontFamily: "Josefin Sans",
            fontSize: 14,
        },
        spanProfil: {
            fontFamily: "Josefin Sans",
            fontSize: 14,
            marginBottom: 20,
        },
        icon: {
            position: "relative",
            top: -4,
        },
        textField: {
            "&::placeholder": {
                color: "#000",
            },
            marginTop: 15,
            marginBottom: 15,
        },
        input: {
            "&::placeholder": {
                textOverflow: "ellipsis !important",
                color: "#000000",
                opacity: 10,
            },
        },
        inputText: {
            marginBottom: 14,
            marginTop: 6,
            textAlign: "left"
        },
        inputAvatar: {
            display: "none",
        },
        cover: {
            fontSize: 18,
            fontWeight: "normal",
            textAlign: "left",
            marginBottom: 33,
        },
        img: {
            maxWidth: 250,
            maxHeight: 150,
        },
        star: {
            marginTop: 10,
        },
    })
);
export const ProfilHôtel = (props: any) => {
    const classes = styles();
    const { t } = useTranslation<'common'>();
    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }, [])

    return (
        <Grid container direction="column" style={{ margin: "0 auto" }}>
            <Grid item lg={12} sm={12} xs={12}>
                <label
                    htmlFor="propertyCountry"
                    className={classes.inputLabel}
                    style={{ display: "block",textAlign:"initial" }}
                >
                    {t('label.types-de-proprietes')}
                </label>
            </Grid>
            <Grid item lg={12} sm={12} xs={12} className={classes.inputText}> 
                    <AutoCompleteSolo id="propertyEquipments" name="name" selectedValues={props.typeSelected} values={props.propertyTypeList} onChangeSelect={props.handleChangePropertyType}/>
            </Grid>
            <Grid
                item
                container
                justifyContent="space-between"
                direction="row"
                spacing={5}
                className={classes.gridContainer}
            >
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    className={classes.propertiesCheck}
                >
                    <div className={classes.propertiesCheckbox}>
                        <Grid container style={{ textAlign: "left" }}>
                            <StandardTextField
                                id="hotelCompany"
                                label={`${t(
                                    "hotel.label.nomEtablissement"
                                )} :*`}
                                name="companyName"
                                value={props.hotelInput.companyName}
                                handleChange={(e) =>
                                    props.handleChange(
                                        e.target.name,
                                        e.target.value
                                    )
                                }
                            />
                            <StandardTextField
                                id="hotelCompany"
                                label={`${t("hotel.label.nomProprietaire")} :*`}
                                name="proprietaire"
                                value={props.hotelInput.proprietaire}
                                handleChange={(e) =>
                                    props.handleChange(
                                        e.target.name,
                                        e.target.value
                                    )
                                }
                            />
                            <Grid item lg={4} md={4} sm={4} xs={4}>
                                <SelectEndornmentNation
                                    id="country"
                                    name="countryProprietaire"
                                    values={CountryPhoneList}
                                    IconElement={
                                        props.logourgentProp ? (
                                            <img
                                                style={{ width: 32 }}
                                                src={`${props.logourgentProp}`}
                                                alt={"Flag"}
                                            />
                                        ) : (
                                            ""
                                        )
                                    }
                                    selectedValue=""
                                    handleOnChange={props.handleOnChangeSelect}
                                    handleOnChangeNation={
                                        props.handleOnChangeNationUrgentProp
                                    }
                                />
                            </Grid>
                            <Grid item lg={8} md={8} sm={8} xs={8}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    display="flex"
                                >
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="phoneUrgent"
                                        name="phone"
                                        variant="outlined"
                                        onChange={(e) =>
                                            props.handleChange(
                                                e.target.name,
                                                e.target.value
                                            )
                                        }
                                        value={props.hotelInput.phone}
                                        type="text"
                                        classes={{ root: classes.textField }}
                                        fullWidth
                                        label="contact propriétaire"
                                        InputProps={{
                                            startAdornment: (
                                                <div
                                                    style={{ marginRight: 10 }}
                                                >
                                                    {props.codephoneurgentProp}
                                                </div>
                                            ),
                                            classes: {
                                                input: classes["input"],
                                            },
                                        }}
                                    />
                                </Stack>
                            </Grid>
                            <StandardTextField
                                id="hotelCompany"
                                label={t("hotel.label.nomGerant")}
                                name="gerant"
                                value={props.hotelInput.gerant}
                                handleChange={(e) =>
                                    props.handleChange(
                                        e.target.name,
                                        e.target.value
                                    )
                                }
                            />
                            <Grid item lg={4} md={4} sm={4} xs={4}>
                                <SelectEndornmentNation
                                    id="country"
                                    name="countryUrgent"
                                    values={CountryPhoneList}
                                    IconElement={
                                        props.logourgent ? (
                                            <img
                                                style={{ width: 32 }}
                                                src={`${props.logourgent}`}
                                                alt={"Flag"}
                                            />
                                        ) : (
                                            ""
                                        )
                                    }
                                    selectedValue=""
                                    handleOnChange={props.handleOnChangeSelect}
                                    handleOnChangeNation={
                                        props.handleOnChangeNationUrgent
                                    }
                                />
                            </Grid>
                            <Grid item lg={8} md={8} sm={8} xs={8}>
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    display="flex"
                                >
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="phoneUrgent"
                                        name="numberPhoneUrgent"
                                        variant="outlined"
                                        onChange={(e) =>
                                            props.handleChange(
                                                e.target.name,
                                                e.target.value
                                            )
                                        }
                                        value={
                                            props.hotelInput.numberPhoneUrgent
                                        }
                                        type="text"
                                        classes={{ root: classes.textField }}
                                        fullWidth
                                        label="contact gérant"
                                        InputProps={{
                                            startAdornment: (
                                                <div
                                                    style={{ marginRight: 10 }}
                                                >
                                                    {props.codephoneurgent}
                                                </div>
                                            ),
                                            classes: {
                                                input: classes["input"],
                                            },
                                        }}
                                    />
                                </Stack>
                            </Grid>
                            <PropertyTextFieldNumber
                                id="propertyMaximumGuests"
                                label={`${t("hotel.label.nombreChambres")} :*`}
                                name="rooms"
                                value={props.hotelInput.rooms === 0 ? "" : props.hotelInput.rooms}
                                placeholder="0"
                                handleChange={(e) =>
                                    props.handleChange(
                                        e.target.name,
                                        e.target.value
                                    )
                                }
                            />

                            <AnnounceTextFieldMultine
                                id="announceDescription"
                                label="Description"
                                name="description"
                                value={props.hotelInput.description}
                                handleChange={(e) =>
                                    props.handleChange(
                                        e.target.name,
                                        e.target.value
                                    )
                                }
                            />
                            {
                                props.typeSelected.name==="Hôtel" && <Grid
                                item
                                container
                                direction="row"
                                className={classes.star}
                            >
                                <Typography component="legend">
                                    {t("hotel.label.nbrStar")} :
                                </Typography>
                                <Rating
                                    name="simple-controlled"
                                    value={props.note}
                                    onChange={props.onChangeStar}
                                />
                            </Grid>
                            }
                            
                        </Grid>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    );
};
